import type { ReactNode } from "react";

interface Props {
  eyebrow: string;
  title: string;
  /** right-aligned actions */
  children?: ReactNode;
}

export function PageHeader({ eyebrow, title, children }: Props) {
  return (
    <div className="flex items-end justify-between gap-4">
      <div>
        <div className="mb-1 font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-muted-foreground">
          {eyebrow}
        </div>
        <h1 className="font-display text-2xl font-semibold tracking-tight">{title}</h1>
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
